import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import Logo from '../assets/Images/fully-final-logo.png';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import axios from 'axios'; // Ensure axios is imported
import { toast } from 'react-toastify';
export default function Footer() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    try {
       const payload = {
            Subject: 'Lead From MagnAid Website',
            Data: {
               email,
          pageUrl: window.location.href
            },
        };
      const response = await axios.post(
        'https://maxaidapi.azurewebsites.net/api/EmailApi',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            code: 'ejJkX3l8qSvgulht0AFLPDySiepq0di50UeRGPa4r5VBAzFudFpISA==',
          },
        }
      );
      const dataMessage = response.data;
      if (dataMessage.status === 'Success') {
        setLoading(false)
        toast.success('Subscription request sent! Check your email for confirmation.')
        setEmail('')
      } else {
       
       toast.error('Something went wrong', dataMessage.message);
      }
    } catch (err) {
       console.error('Failed to send email:', error.response?.data || error.message);
              toast.error(
                  'Failed to send email',
                  error.response?.data || error.message,
                  { style: { color: 'black' } }
              );
    }finally {
        setLoading(false);
    }
  };
  // Define main pages with their routes
  const mainPages = [
    { name: 'home', path: '/' },
    { name: 'about', path: '/about-us' },
    { name: 'pricing', path: '/laboratory-services-in-hospital' },
    { name: 'contact us', path: '/contact-us' },
    { name: 'cardiology', path: '/cardiology-hospitals-in-hyderabad' },
    { name: 'radiology', path: '/radiology' },
    { name: 'pulmonology', path: '/best-pulmonology-hospital-hyderabad' },
    { name: 'pediatrics', path: '/best-pediatrics-hospitals' },
    { name: 'anaesthesia', path: '/anesthesia-and-pain-management' },
    { name: 'nephrology', path: '/nephrology-hospital' },
    { name: 'psychiatry', path: '/best-psychiatrist-in-hyderabad' },
    { name: 'gastroenterology', path: '/best-gastroenterologist-in-hyderabad' },
    { name: 'ENT', path: '/ent-hospital-in-hyderabad' },
    { name: 'spine surgery', path: '/spine-surgery-hospitals' },
    { name: 'neurosurgery', path: '/neurosurgery' },
    { name: 'urology', path: '/best-urologist-in-hyderabad' },
    { name: 'orthopedics', path: '/hyderabad-orthopedic-hospital' },
    { name: 'general medicine', path: '/general-surgery' },
  ];

  // Define utility pages with their routes
  const utilityPages = [
    { name: 'Lab & Diagnostics', path: '/laboratory-services-in-hospital' },
    { name: 'Terms and Conditions', path: '/terms-and-conditions' },
    { name: 'Privacy Policy', path: '/privacy-policy' },

  ];

  const phoneNumber = '917993999044';
  const whatsappMessage = 'Hi'; // Renamed to avoid conflict
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <>
      <footer className="pt-20 pb-16">
        <div className="max-w-[1340px] px-[24px] md:px-[24px] xl:px-[0px] mx-auto grid grid-cols-1 xl:grid-cols-[1.7fr_1.5fr_1fr_1fr] gap-12">
          {/* Column 1: Logo & Newsletter */}
          <div>
            <Link to="/" className="block mb-[24px]">
              <img src={Logo} alt="Logo" />
            </Link>
            <p className="text-[20px] font-medium text-paraGreen leading-[1.667em] font-body mb-[24px]">
              Best Multi-Speciality Hospital
              <br />
              Redefined Healthcare in your Neighborhood
            </p>
            <div className="relative">
              <form className="relative mb-4" onSubmit={handleSubmit}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email} disabled={loading}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-3 pl-10 border border-gray-300 rounded-[4px] focus:outline-none text-[18px] font-body text-thickGreen placeholder:text-thickGreen"
                />
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-orange text-[20px]"
                />

                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
              </form>
              <button
                type="submit"
                onClick={handleSubmit} disabled={loading}
                className="bg-lightGreen text-white px-[38px] py-4 rounded-[80px] font-bold font-body lowercase text-[20px] transition hover:bg-orange"
              >
                {
                  loading ? 'Subscribing' : 'Subscribe'
                }
              </button>
            </div>
          </div>

          {/* Column 2: Main Pages */}
          <div>
            <p className="text-[22px]  text-thickGreen font-heading mb-[32px]">
              Main Pages
            </p>
            <div className="grid grid-cols-2 gap-x-6 gap-y-2">
              {mainPages.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className="space-y-2 text-[20px] text-paraGreen font-body capitalize"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Column 3: Utility Pages */}
          <div className="w-[180px]">
            <p className="text-[22px]  text-thickGreen font-heading mb-[32px]">
              Utility Pages
            </p>
            <ul className="space-y-2 text-[20px] text-paraGreen font-body">
              {utilityPages.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    className={`transition ${item.name === 'more Novatales templates' ? 'font-bold' : ''}`}
                    target={item.external ? '_blank' : undefined}
                    rel={item.external ? 'noopener noreferrer' : undefined}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact Details */}
          <div>
            <p className="text-[22px] text-thickGreen font-heading mb-[32px]">
              Contact Us
            </p>
            <div className="space-y-6 text-lg text-paraGreen">
              <div className="flex items-center gap-2">
                <FontAwesomeIcon icon={faLocationDot} className="text-orange text-lg" />
                <p className="font-medium font-body text-[20px] my-3">Location</p>
              </div>
              <Link
                to="https://maps.app.goo.gl/ae7ic19m3CFTA5c48"
                target='_blank'
                className="text-[22px] font-medium text-thickGreen font-heading mb-[32px]"
              >
                Yousufguda Main Rd., Yella Reddy Guda
              </Link>
              <div className="border-b border-gray-300 my-6"></div>
              <div className="flex items-center gap-2">
                <FontAwesomeIcon icon={faEnvelope} className="text-orange text-lg" />
                <p className="font-medium font-body text-[20px]">Email Address</p>
              </div>
              <div className='flex flex-col'>
                <Link
                  to="mailto:info@magnaid.com"
                  className="text-[22px] font-medium text-thickGreen font-body mb-3"
                >
                  info@magnaid.com
                </Link>
                <Link
                  to="mailto:magnaidhospitals@gmail.com"
                  className="text-[22px] font-medium text-thickGreen font-body mb-6"
                >
                  magnaidhospitals@gmail.com
                </Link>
              </div>
              <div className="border-b border-gray-300 my-6"></div>
              <div className="flex items-center gap-2">
                <FontAwesomeIcon icon={faPhone} className="text-orange text-lg" />
                <p className="font-medium font-body text-[20px] my-3">Phone Number</p>
              </div>
              <Link
                to="tel:79939 99040"
                className="text-[22px] font-medium text-thickGreen font-body mb-[32px]"
              >
                7993 999 040
              </Link>
              <br />
              <Link
                to="tel:79939 99044"
                className="text-[22px] font-medium text-thickGreen font-body mb-[32px]"
              >
                7993 999 044
              </Link>
            </div>
          </div>
        </div>
      </footer>

      {/* Bottom Section */}
      <div className="max-w-[1340px] mx-auto px-[24px] md:px-[24px] xl:px-[0px]">
        <div className="border-t border-gray-300 text-start py-8">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_0.4fr] items-center gap-4 font-body">
            <p className="text-lg text-paraGreen">
              Copyright @ 2025 MagnAid - Powered by
              <Link
                to="https://www.novatales.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
              >
                {' '}
                Novatales Media
              </Link>
            </p>
            <div className="flex justify-center md:justify-end space-x-4">
              <Link
                to="https://www.facebook.com/magnaidhospital/"
                target="_blank"
                rel="noopener noreferrer" aria-label="facebook icon"
                className="text-lightGreen hover:text-blue-600"
              >
                <FontAwesomeIcon icon={faFacebookF} size="lg" />
              </Link>
              <Link
                to="https://www.instagram.com/MagnAidhospitals/"
                target="_blank" aria-label="instagram icon"
                rel="noopener noreferrer"
                className="text-lightGreen hover:text-pink-600"
              >
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </Link>
              <Link
                to="https://www.linkedin.com/company/magnaid-hospitals/"
                target="_blank"
                rel="noopener noreferrer" aria-label="linkedin icon"
                className="text-lightGreen hover:text-blue-800"
              >
                <FontAwesomeIcon icon={faLinkedinIn} size="lg" />
              </Link>
              <Link
                to="https://youtube.com/@magnaidhospitals?si=bF-OQO3iC4qdZky0"
                target="_blank" aria-label="Youtube Icon"
                rel="noopener noreferrer"
                className="text-lightGreen hover:text-red-600"
              >
                <FontAwesomeIcon icon={faYoutube} size="lg" />
              </Link>
              <Link
                to={whatsappUrl} aria-label="whatsapp icon"
                target="_blank"
                rel="noopener noreferrer"
                className="text-lightGreen hover:text-green-600"
              >
                <FontAwesomeIcon icon={faWhatsapp} size="lg" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}